<template>
  <div class="p-6 space-y-6 bg-white rounded-lg shadow">
    <h2 class="text-xl font-semibold text-gray-700">Assistant Settings</h2>
    <div class="space-y-4">
      <div class="flex items-center justify-between p-4 border rounded-md">
        <label for="autoScreeningSwitch" class="text-gray-600"
          >Auto screening</label
        >
        <Switch id="autoScreeningSwitch" v-model="autoScreeningEnabled" />
      </div>
      <div class="p-4 border rounded-md space-y-3">
        <div class="flex items-center justify-between">
          <label for="autoExtractionSwitch" class="text-gray-600"
            >Auto extraction</label
          >
          <Switch id="autoExtractionSwitch" v-model="autoExtractionEnabled" />
        </div>
        <p
          v-if="autoExtractionEnabled"
          class="text-sm text-orange-600 bg-orange-50 p-3 rounded-md"
        >
          <span class="font-semibold">Caution:</span> This operation could be
          expensive depending on the number of documents and their size. If
          you're unsure, please turn this off.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Switch from '@app/components/Global/Switch.vue'
import { injectStrict } from '@app/utils/injectStrict'
import { CreateReviewKey } from '../../useCreateProjectReview'
import { computed } from 'vue'

const { preset } = injectStrict(CreateReviewKey)

const autoScreeningEnabled = computed({
  get: () => !preset.value.isAutoScreeningPaused,
  set: (value: boolean) => {
    preset.value.isAutoScreeningPaused = !value
  },
})

const autoExtractionEnabled = computed({
  get: () => !preset.value.isAutoExtractionPaused,
  set: (value: boolean) => {
    preset.value.isAutoExtractionPaused = !value
  },
})
</script>
